import { Country } from '~/Api/Country';
import { DataSource } from '~/Api/DataSource';

export type AnalyticDataSource = { dataSource: DataSource | null; country: Country; hasPrice: boolean };
export type AnalyticDataSources = AnalyticDataSource[];

export class VirtualPackBrandAnalytics {
	id: string;
	distinctName: string;
	dataSources: AnalyticDataSources;

	constructor(params: { id: string; distinctName: string; dataSources: AnalyticDataSources }) {
		this.id = params.id;
		this.distinctName = params.distinctName;
		this.dataSources = params.dataSources.map(({ dataSource, country, hasPrice }) => ({
			hasPrice,
			dataSource: dataSource
				? new DataSource(
						dataSource.type,
						dataSource.shortName,
						dataSource.description,
						dataSource.country,
						dataSource.requiresLicence
				  )
				: null,
			country: new Country(country.alpha2, country.name),
		}));
	}
}

export class VirtualBrandAnalytics {
	id: string;
	brandName: string;
	virtualPacks: {
		id: string;
		dataSources: AnalyticDataSources;
		distinctName: string;
	}[];

	constructor(params: {
		id: string;
		brandName: string;
		virtualPacks: {
			id: string;
			dataSources: AnalyticDataSources;
			distinctName: string;
		}[];
	}) {
		this.id = params.id;
		this.brandName = params.brandName;
		this.virtualPacks = params.virtualPacks.map(
			(rawVirtualPackData) => new VirtualPackBrandAnalytics(rawVirtualPackData)
		);
	}
}

export interface RawAnalyticVirtualPack {
	id: string;
	distinctName: string;
	virtualPacks: {
		id: string;
		dataSources: AnalyticDataSources;
		distinctName: string;
	}[];
}

export interface RawAnalyticVirtualBrand {
	id: string;
	brandName: string;
	virtualPacks: {
		id: string;
		dataSources: AnalyticDataSources;
		distinctName: string;
	}[];
}

export default function mapVirtualBrandAnalytics(
	rawVirtualBrandAnalytics: RawAnalyticVirtualBrand
): VirtualBrandAnalytics {
	return new VirtualBrandAnalytics(rawVirtualBrandAnalytics);
}
